// Frontend
import { Tooltip } from 'react-tooltip';
import { FaInfoCircle } from 'react-icons/fa';

import PropTypes from 'prop-types';

function Sidebar({ submissionUnlocked }) {

  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <>
      {submissionUnlocked && (
        <div className="reactflow-aside">
          <div className="reactflow-aside__description-container">
            <p className="reactflow-aside__description">Add by clicking and dragging.</p>
            <span className="reactflow-aside__info-icon" title="Click for more information about adding nodes">
              <FaInfoCircle size={16} color="#000000" />
            </span>
          </div>

          <ul className="reactflow-aside-nodes-list">
            <li
              className="reactflow-aside-nodes-list__item reactflow-aside-nodes-list__item--why"
              onDragStart={(event) => onDragStart(event, 'whyNode')}
              draggable
            >
              Why
            </li>
            <li
              className="reactflow-aside-nodes-list__item reactflow-aside-nodes-list__item--impact"
              onDragStart={(event) => onDragStart(event, 'impactNode')}
              draggable
            >
              Impact
            </li>
          </ul>

          <Tooltip id="why-tooltip" />
          <Tooltip id="impact-tooltip" />
        </div>
      )}
    </>
  );
}

export default Sidebar;

Sidebar.propTypes = {
  submissionUnlocked: PropTypes.bool.isRequired,
}
